/* eslint-disable id-length */
import { React, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  CANCEL_TEXT,
  NOTE,
  PROJECTS_PROFILE,
  SAVE,
} from '../../../Constants/strings';
import FormDialog from '../../../Components/Modal/modal';
import CommonTextField from '../../../Components/TextField/textField';
import CommonDatePicker from '../../../Components/Datepicker/datepicker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'dayjs/locale/en';
import SearchDropdown from '../../../Components/Dropdown/dropdown';
dayjs.extend(customParseFormat);

dayjs.locale({
  ...dayjs.Ls.en,
  formats: {
    ...dayjs.Ls.en.formats,
    L: 'DD-MM-YYYY',
  },
});

const RecognitionModal = ({
  isOpen,
  newRecognition,
  monthNames,
  handleRecognitionChange,
  closeRecognitionModal,
  saveRecognition,
}) => {
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const currentDate = new Date();

  useEffect(() => {
    const getCurrentYear = () => new Date().getFullYear();
    const yearsArray = Array.from(
      { length: getCurrentYear() - 2010 + 1 },
      (year, index) => ({
        id: index + 1,
        name: String(2010 + index),
      }),
    );
    setYears(yearsArray);
    const monthsArray = monthNames.map((month, index) => ({
      id: index + 1,
      name: month,
    }));
    setMonths(monthsArray);
  }, []);

  const dialogBodyContent = (
    <>
      <div className="title-container">
        <label htmlFor="star-appreciation">
          <input
            type="radio"
            name="type"
            value="Star of the month"
            className="star-appreciation"
            checked={newRecognition.type === 'Star of the month'}
            onChange={handleRecognitionChange}
          />
          {PROJECTS_PROFILE.STAR_OF_THE_MONTH}
        </label>
        <label htmlFor="client-appreciation">
          <input
            type="radio"
            name="type"
            value="Client appreciation"
            className="client-appreciation"
            checked={newRecognition.type === 'Client appreciation'}
            onChange={handleRecognitionChange}
          />
          {PROJECTS_PROFILE.CLIENT_APPRECIATION}
        </label>
      </div>
      <div className="feedback-container">
        <CommonTextField
          textCss="feedback-textarea"
          label={PROJECTS_PROFILE.FEEDBACK}
          value={newRecognition.feedback}
          onChange={(e) =>
            handleRecognitionChange({
              target: { name: 'feedback', value: e.target.value },
            })
          }
          placeholder={PROJECTS_PROFILE.FEEDBACK_PLACEHOLDER}
          size="small"
          id="feedback-textarea"
          multiline
          rows={4}
          maxLengthCount={250}
        />
      </div>
      {newRecognition.type === 'Client appreciation' && (
        <div className="form-row">
          <div className="form-group-date">
            <CommonDatePicker
              label={PROJECTS_PROFILE.CHOOSE_DATE}
              minDate={dayjs('01-01-2010')}
              maxDate={dayjs(currentDate)}
              placeholder={PROJECTS_PROFILE.DATE_PLACEHOLDER}
              value={newRecognition.date ? dayjs(newRecognition.date) : null}
              onChange={(date) =>
                handleRecognitionChange({
                  target: { name: 'date', value: date },
                })
              }
              className="custom-calender"
            />
          </div>
          <div className="form-group-client">
            <CommonTextField
              textCss="recognition-client-name"
              label={PROJECTS_PROFILE.CLIENT_NAME}
              value={newRecognition.clientName}
              onChange={(e) =>
                handleRecognitionChange({
                  target: { name: 'clientName', value: e.target.value },
                })
              }
              placeholder={PROJECTS_PROFILE.CLIENT_PLACEHOLDER}
              size="small"
              id="recognition-cleent-name"
              maxLengthCount={50}
            />
          </div>
        </div>
      )}
      {newRecognition.type === 'Star of the month' && (
        <div className="select-container">
          <SearchDropdown
            options={years}
            label=""
            placeholder={PROJECTS_PROFILE.SELECT_YEAR}
            value={newRecognition.year.name}
            onChange={(e) =>
              handleRecognitionChange({
                target: { name: 'year', value: e.target.value.name },
              })
            }
            searchBox={false}
            id="recognition-year-dropdown"
            dropdownCss="add-recognition-year"
          />
          <SearchDropdown
            options={months}
            label=""
            placeholder={PROJECTS_PROFILE.SELECT_MONTH}
            value={newRecognition.month.name}
            onChange={(e) =>
              handleRecognitionChange({
                target: { name: 'month', value: e.target.value.name },
              })
            }
            searchBox={false}
            id="recognition-month-dropdown"
            dropdownCss="add-recognition-month"
          />
        </div>
      )}
      {newRecognition.type === 'Star of the month' && (
        <div className='note-container'>
          <p className='note'>
            <span className='note-text'>{NOTE} </span>{PROJECTS_PROFILE.NOTE_MESSAGE}
          </p>
        </div>
      )}
    </>
  );

  return (
    <FormDialog
      title={PROJECTS_PROFILE.ADD_RECOGNITION}
      open={isOpen}
      handleClose={closeRecognitionModal}
      button1Action={closeRecognitionModal}
      button2Action={saveRecognition}
      dialogCss="recognition-dialog"
      dialogPaperCss="recognition-dialog-paper"
      dialogBodycontent={dialogBodyContent}
      button1={CANCEL_TEXT}
      button2={SAVE}
      cancelButtonId="cancel-recognition-btn"
      submitButtonId="save-recognition-btn"
    />
  );
};

RecognitionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  newRecognition: PropTypes.object.isRequired,
  monthNames: PropTypes.array.isRequired,
  handleRecognitionChange: PropTypes.func.isRequired,
  closeRecognitionModal: PropTypes.func.isRequired,
  saveRecognition: PropTypes.func.isRequired,
};

export default RecognitionModal;
